 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		384: 0,
 		280: 0,
 		281: 0,
 		288: 0,
 		289: 0,
 		290: 0,
 		338: 0,
 		339: 0,
 		346: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","217":"AddClosedAlertIDUseCase","218":"CreateDeviceUseCase","219":"CreateDomestikaFollowUseCase","220":"CreateJWTUserUseCase","221":"CreateUserLiveSessionUseCase","222":"CurrentUserUseCase","223":"CurrentWithoutRelationshipsUserUseCase","224":"DeleteDeviceUseCase","225":"DeleteFollowUseCase","226":"ENV_CONFIG1","227":"ENV_CONFIG4","228":"ENV_CONFIG5","229":"ENV_CONFIG6","230":"ENV_CONFIG7","231":"FinishUserLiveSessionUseCase","232":"GetAccessTokenUserUseCase","233":"GetAdvanceGDPRStatusUserUseCase","234":"GetAllBlogUseCase","235":"GetAreasCourseUseCase","236":"GetCartCourseUseCase","237":"GetCategoriesCourseUseCase","238":"GetCourseUseCase","239":"GetFinalProjectVideoByCourseIDCourseUseCase","240":"GetGDPRStatusUserUseCase","241":"GetListLiveFeedbackQuestionUseCase","242":"GetListLiveSessionUseCase","243":"GetListLiveStreamUseCase","244":"GetLiveChannelUseCase","245":"GetLiveSessionUseCase","246":"GetOrganizationUseCase","247":"GetPlusPromotionUseCase","248":"GetPostContentBlogUseCase","249":"GetPromotionCodeAlertUseCase","250":"GetPromotionUseCase","251":"GetPubnubCredentialsUseCase","252":"GetSessionDataUserUseCase","253":"GetSimpleUserUseCase","254":"GetSoftwaresCourseUseCase","255":"GetUserAlertUseCase","256":"GetVideoProgressListCourseUseCase","257":"GetVideoSpeedUserUseCase","258":"GetVideoVolumeUserUseCase","259":"LogoutUserUseCase","260":"PathToRegexp","261":"RefreshAccessTokenUserUseCase","262":"RemoveAccessTokenUserUseCase","263":"SearchCourseUseCase","264":"SendHeaderTrackingUseCase","265":"SendLiveFeedbackAnswersUseCase","266":"SendPlayerTrackingUseCase","267":"SendTrackingUseCase","268":"SendVideoProgressCourseUseCase","269":"SetAdvanceGDPRStatusUserUseCase","270":"SetGDPRStatusUserUseCase","271":"SetVideoSpeedUserUseCase","272":"SetVideoVolumeUserUseCase","273":"UpdateLanguageUserUseCase","274":"UpdateLiveSessionUseCase","275":"UpdateVideoAudioAndSubtitlesCourseUseCase","276":"UpdateVideoProgressCourseUseCase","277":"ViewPageTrackingUseCase","347":"vendors~AddClosedAlertIDUseCase","348":"vendors~AmplitudeJS","349":"vendors~SearchCourseUseCase","350":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"983822b1f05bc998d954","1":"1055e1b76b1570112803","2":"09e837b8eb3a6da68a62","3":"474676dad1aaee493e6c","4":"accbe76947d14647bd7f","5":"19f435ba1f05370cd5d8","6":"b1bd816612147766498c","216":"7e94d8223f53f6d46a70","217":"858f69162da78627a6ca","218":"ddfeb9f67eb73dc4b43f","219":"98c206fd4d7156e20537","220":"940f5e96878282636391","221":"ec07e6835db2a57cbcdc","222":"ae21fe5b1ed3578e3432","223":"8c23e4ac8a1041bce1f1","224":"0c12c31a504c362a9a6a","225":"91819d403a741859f37a","226":"f1c43e61a9cd6af4b62a","227":"7c5637ffa7ad5e2d4a61","228":"414384cfa4cf5a7a449a","229":"6b8c2e96facae9eda6fe","230":"beda36b5457f95a3cbbd","231":"b50fa6c6d096f2a38d1a","232":"d70e9cc83fb8db098a4d","233":"a5b765059cff792596ae","234":"e42cd507ef5113bfc3f8","235":"c61165f6676df2e6ea56","236":"9e0836eee150c004f9cf","237":"7ad6cbb717c5a0f7e09a","238":"4c6b1bb03f843c535f2d","239":"bbcfdd60d31a4b3be25e","240":"7d7d12527f335b79f59b","241":"8291ae4e4a77e95b0048","242":"657efddce5914b56f2cd","243":"14711e16e65437911585","244":"2cce69fa06a42b175c37","245":"df86874a28f9973c2f16","246":"8f378a9a5897918ffdc0","247":"6620a18952b0d9b24a6d","248":"3baadc555d97d60c0598","249":"256b0a4b687dac4cce93","250":"5f95bea735a97a591e54","251":"66f9b64841b3031f31da","252":"daeed809443b4bfeda42","253":"5d7ed4205a4a8a80c78d","254":"ea8aeb51ea81bf27bc95","255":"b6e04e91f719a188f50a","256":"0be69bd8a5a27007105c","257":"5fb38155bb8bc0219c28","258":"96d95f72f2dea4d643ae","259":"3743d9a8eeda7319f807","260":"322a34b8485ed4b0a791","261":"99fb37614f77c3f823c3","262":"4626484ad62086e532c8","263":"b4d5186c92e473b8ad86","264":"c2f13715b233ef9016eb","265":"7d7e4e22d5d96602a5c8","266":"d93b72fe2171509513a5","267":"44171ef9bb15d303865b","268":"a5f78ab72d06e3522d11","269":"0f55dd9747c9ca00fded","270":"d52845f642da6539d0e4","271":"65f0376f1e1a51b9de68","272":"8a46a06ee341fbb08704","273":"7fea060c7302bb418abb","274":"0c0a6af9ea9390980210","275":"5252ccb370c268dd6ed2","276":"c074a7825d9bdec3ac51","277":"b4bf98f92f451b8b4900","347":"da180a4a9e1ccd77d30d","348":"96ac8b6bce4cd257bf84","349":"74068faa9e724c7c62b2","350":"50ae7534c3b9b3524331","419":"999e93dc8bc6b55f628e","421":"36c564833ed22509947d","422":"48bd6326ce803376d1be","640":"cde6e6d44f49b5cbcb28","641":"8bbfb5e0e7e6caf8ffeb","642":"d9d385dc1d69aa1b3324"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2173);
